import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useTeacherToolsGet = (params) => {
  const { selectedTool, content, assumedLevel, skip } = params;
  const resource = `${MONOLITH_ORIGIN}/api/v3/content/${content?.id}/${selectedTool}/?level_id=${assumedLevel?.id}`;

  return useRestQuery(resource, {
    skip: !selectedTool || !content || !assumedLevel || skip,
  });
};

export default useTeacherToolsGet;
